// Mock API for UI testing (jsonplaceholder)
export const MOCK_API_BASE = 'https://jsonplaceholder.typicode.com';

// Real API for production
export const API_BASE = 'https://api.kingrecharges.com';

export default {
  EVENTS: {
    DASHBOARD: {
      REFRESH: 'dashboard.refresh',
      STATS_LOADED: 'dashboard.stats.loaded',
    },
    DASHBOARD_TRANSACTIONS: {
      LIST: 'dashboard.transactions.list',
      LIST_LOADED: 'dashboard.transactions.list.loaded',
    },
    DASHBOARD_SUBSCRIPTIONS: {
      LIST: 'dashboard.subscriptions.list',
      LIST_LOADED: 'dashboard.subscriptions.list.loaded',
    }
  },
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/user/kingrecharges/login?group=lacasae',
      REGISTER: '/user/kingrecharges/register?group=lacasae',
      REFRESH: '/user/kingrecharges/{userId}?group=lacasae',
    },
    TRANSACTIONS: {
      LIST: '/todos/1',
      LIST_REAL: '/user/kingrecharges/{userId}/transactions?group=lacasae',
    },
    SUBSCRIPTIONS: {
      LIST: '/todos/2',
      LIST_REAL: '/user/kingrecharges/{userId}/subscriptions?group=lacasae',
    },
    STATS: {
      LIST: '/todos/3',
    }
  }
};
